import {spawn, call, all} from 'redux-saga/effects';
import {delay} from 'redux-saga';
import loginSaga from './loginSaga';
import dependencySaga from 'framework/sagas/dependencySaga';
import dynamicSaveSaga from './deprecatedSaveSaga';
import saveEntitySaga from 'framework/sagas/saveEntitySaga';
import validationSaga from 'framework/sagas/validationSaga';
import saveLocationDataSaga from './saveLocationDataSaga';
import collaborationSetupSaga from 'framework/sagas/collaborationSaga';

const makeRestartable = (saga) => {
  return function* () {
    yield spawn(function* () {
      yield call(restartLoop, saga);
    });
  };
};

export function* restartLoop(saga) {
  try {
    yield call(saga);
    console.error(
      'unexpected root saga termination. The root sagas are supposed to be sagas that live during the whole app lifetime!',
      saga
    );
  } catch (e) {
    console.error('Saga error, the saga will be restarted', e);
  }
  yield delay(1000); // Workaround to avoid infinite error loops
  yield call(restartLoop, saga);
}

const rootSagas = [
  loginSaga,
  dependencySaga,
  dynamicSaveSaga,
  saveEntitySaga,
  validationSaga,
  saveLocationDataSaga,
].map(makeRestartable);

// collaborationSetupSaga has error handling internally
rootSagas.push(collaborationSetupSaga);

export default function* root() {
  yield all(rootSagas.map((saga) => call(saga)));
}
